import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "rootEl",
  class: "base-datepicker"
}
const _hoisted_2 = { class: "base-datepicker__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 1L1 7l6 6",
    stroke: "#201E1E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "base-datepicker__header-content",
  "aria-live": "polite"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 13l6-6-6-6",
    stroke: "#201E1E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "base-datepicker__picker",
  role: "grid",
  "aria-labelledby": "id-dialog-label"
}
const _hoisted_9 = {
  key: 0,
  class: "base-datepicker__days-header"
}
const _hoisted_10 = { class: "base-datepicker__body" }
const _hoisted_11 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "base-datepicker__previous-month",
        "aria-label": "previous month",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args)))
      }, _hoisted_4),
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.header), 1),
      _createElementVNode("button", {
        class: "base-datepicker__next-month",
        "aria-label": "next month",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
      }, _hoisted_7)
    ]),
    _createElementVNode("table", _hoisted_8, [
      (_ctx.showDaysHeader)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_9, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerDays, ({ abbr, short }) => {
                return (_openBlock(), _createElementBlock("th", _mergeProps({
                  key: short,
                  scope: "col"
                }, { abbr }), _toDisplayString(short), 17))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("tbody", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysGrid, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            class: "base-datepicker__row"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (day, dayIndex) => {
              return (_openBlock(), _createElementBlock("td", {
                key: dayIndex,
                class: _normalizeClass(["base-datepicker__day", {
							'base-datepicker__day--empty': _ctx.isEmpty(day),
							'base-datepicker__day--selected': _ctx.isSelected(day),
							'base-datepicker__day--is-disabled': _ctx.isDisabled(day),
						}])
              }, [
                (!_ctx.isEmpty(day))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "base-datepicker__day-button",
                      disabled: _ctx.isDisabled(day),
                      tabindex: "-1",
                      type: "button",
                      onClick: ($event: any) => (_ctx.onDayClicked(day))
                    }, _toDisplayString(day), 9, _hoisted_11))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 512))
}